import { render, staticRenderFns } from "./FrontdeskPage.vue?vue&type=template&id=3237956f&scoped=true"
import script from "./FrontdeskPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FrontdeskPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FrontdeskPage.vue?vue&type=style&index=0&id=3237956f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3237956f",
  null
  
)

export default component.exports